import { inject, Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { UserRole } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { Memoize } from '@ti/core/common/decorators'
import { LanguageService } from '@ti/core/ui-kit/i18n'

@Injectable()
export class UserRolesProvider {
  protected readonly api = inject(ApiService)
  protected readonly languageService = inject(LanguageService)

  @Memoize()
  get userRoleLabels$(): Observable<Record<UserRole, string>> {
    const roleList = Object.values(UserRole)
    const labelsMap: Record<number, string> = {}
    roleList.forEach((roleId) => {
      labelsMap[roleId as number] = `users.roles.${roleId}`
    })
    return this.languageService.massTranslate$(labelsMap)
  }
}
